import { Content } from '@ynap/api-utils';
import apiAction from '@ynap/api-fetch-action';
import { deliveryReturnsCache } from 'app/components/product-details-page/DeliveryAndReturns/utils/DeliveryReturnsCache';
import { DELIVERY_RETURNS_CONTENT_SUCCESS } from '../constants';

export const fetchDeliveryReturnsContent = () => {
    return async (dispatch, getState) => {
        const state = getState();
        const { country, language } = state.appState;
        const { services, application } = state.config.global;
        const { content: contentService } = services;
        const { brandId } = application;

        const existingContent = state?.pdp?.deliveryReturnsContentState?.response;
        if (existingContent && existingContent.body) {
            return existingContent;
        }

        const cacheKey = deliveryReturnsCache.generateKey(brandId, country, language);

        const cachedContent = deliveryReturnsCache.get(cacheKey);
        if (cachedContent) {
            return dispatch({
                type: DELIVERY_RETURNS_CONTENT_SUCCESS,
                body: cachedContent.json,
                headers: cachedContent.headers,
                status: cachedContent.status || 200,
            });
        }

        try {
            const request = Content.getContentByComponent({
                baseUrl: contentService.baseUrl,
                brandId,
                country,
                language,
                componentKey: 'delivery-and-returns-info-legal',
                clientId: contentService.clientId,
                coreMediaLocale: state.appState.langISO,
                options: {
                    mv: 'gitMarkdown',
                    noCommerce: true,
                    f: 'ycos',
                },
            });

            const response = await dispatch(apiAction(request, 'DELIVERY_RETURNS_CONTENT', null, { reqTimeout: 3000 }));

            if (response && !response.errorCode) {
                deliveryReturnsCache.set(cacheKey, response);
            }

            return response;
        } catch (error) {
            if (error instanceof Error) {
                console.log('Error prefetching delivery returns content:', error.message);
            }
            return null;
        }
    };
};
